import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  Box,
  Button,
  Drawer,
  DialogContent,
  Typography,
  Select,
  MenuItem,
  IconButton,
  TextField,
  Paper,
  CircularProgress,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogActions,
  Tooltip
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import TicketCard from "./TicketCard";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { getAllTicketsForUnification, unificationTickets, getCalledInfo } from "src/services/unificationticket.service";
import CustomizedSnackbars from "../material-snackbars";
import { Overlay } from "../../styles/global";

export default function MergeTicketModal(props) {
  const { open, openHandleMenuOpenTicket, called } = props;

  const requestingUserId = useMemo(() => called?.requestinguserid, [called]);
  const [step, setStep] = useState(1);
  const [filterType, setFilterType] = useState("id");
  const [searchInput, setSearchInput] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [principal, setPrincipal] = useState(called?.id || null);
  const [selectedTickets, setSelectedTickets] = useState(called ? [called] : []);
  const [searchResults, setSearchResults] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  const [ticketAnnotations, setTicketAnnotations] = useState({});
  const [editingTickets, setEditingTickets] = useState({});
  const [tempAnnotations, setTempAnnotations] = useState({});
  const [annotationVisibility, setAnnotationVisibility] = useState({});
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const searchTimeoutRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const colorTheme = '#97c05c';

  const handleClose = () => {
    openHandleMenuOpenTicket(false);
    setStep(1);
    setSearchInput("");
    setSearchResults([]);
    setSelectedTickets(called ? [called] : []);
    setPrincipal(called?.id || null);
    setTicketAnnotations({});
    setEditingTickets({});
    setTempAnnotations({});
    setAnnotationVisibility({});
  };
  const searchTickets = async (searchValue, type) => {
    if (!searchValue.trim()) {
      setSearchResults([]);
      return;
    }

    setIsSearching(true);
    
    try {
      let id = "";
      let title = "";

      if (type === "id") {
        id = parseInt(searchValue);
      } else if (type === "titulo") {
        title = searchValue;
      }

      const idsException = selectedTickets.map(ticket => ticket.id).join(',');
      const response = await getAllTicketsForUnification(requestingUserId, id, title, idsException, called?.organizationid);

      if (response.success && response.data) {
        const results = Array.isArray(response.data) 
          ? response.data 
          : [response.data];
        
        setSearchResults(results);
        
        if (results.length === 0) {
          showSnackbar("Nenhum chamado encontrado para este solicitante", "error");
        }
      } else {
        setSearchResults([]);
        showSnackbar("Nenhum chamado encontrado", "error");
      }
    } catch (error) {
      console.error("Erro ao buscar chamados:", error);
      setSearchResults([]);
      
      if (error.response?.status === 404) {
        showSnackbar("Chamado não encontrado", "error");
      } else if (error.response?.status === 401) {
        showSnackbar("Sessão expirada. Faça login novamente", "error");
      } else {
        showSnackbar("Erro ao buscar chamados. Tente novamente", "error");
      }
    } finally {
      setIsSearching(false);
    }
  };

  useEffect(() => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    if (!searchInput.trim()) {
      setSearchResults([]);
      setIsSearching(false);
      return;
    }

    setIsSearching(true);

    searchTimeoutRef.current = setTimeout(() => {
      searchTickets(searchInput, filterType);
    }, 1500);

    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, [searchInput, filterType]);

  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  const showSnackbar = (message, severity = "error") => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleAddTicket = (ticket) => {
    if (!selectedTickets.some(t => t.id === ticket.id)) {
      const newSelectedTickets = [...selectedTickets, ticket];
      setSelectedTickets(newSelectedTickets);
      
      if (newSelectedTickets.length === 1) {
        setPrincipal(ticket.id);
      }
      
      showSnackbar("Chamado adicionado com sucesso", "success");
    }
  };
  
  const clearSearch = () => {
    setSearchInput("");
    setSearchResults([]);
  }

  const handleRemoveTicket = (ticketId) => {
    if (ticketId === called?.id) {
      showSnackbar("Não é possível remover o chamado original");
      return;
    }
    
    if (ticketId === principal) {
      showSnackbar("Não é possível remover o chamado principal");
      return;
    }

    setSelectedTickets(selectedTickets.filter((ticket) => ticket.id !== ticketId));
    showSnackbar("Chamado removido com sucesso", "success");
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const getDefaultAnnotation = (ticket) => {
    //return `<p>O chamado com o ID <a target="_blank" href="/pt/called-accompaniment/deleted/${ticket.id}">#${ticket.id}</a> foi unificado neste chamado.</p>
    return `<p>O chamado com o ID <strong>#${ticket.id}</strong> foi unificado neste chamado.</p>
      <p><br></p>
      <p><strong>Título:</strong> ${ticket.title}</p>
      <p><br></p>
      <p>Foi anexado nesse chamado todos seus acompanhamentos e anexos.</p>`;
      //<p>Para mais informações acesse o chamado.</p>;
  };

  const handleContinue = () => {
    if (selectedTickets.length < 2) {
      showSnackbar("Selecione pelo menos 2 chamados para unificar");
      return;
    }

    const annotations = {};
    const visibility = {};
    
    selectedTickets.forEach((ticket) => {
      if (ticket.id !== principal) {
        annotations[ticket.id] = getDefaultAnnotation(ticket);
        visibility[ticket.id] = "private";
      }
    });
    
    setTicketAnnotations(annotations);
    setAnnotationVisibility(visibility);
    setStep(2);
  };

  const handleEditAnnotation = (ticketId) => {
    setEditingTickets({ ...editingTickets, [ticketId]: true });
    setTempAnnotations({ 
      ...tempAnnotations, 
      [ticketId]: ticketAnnotations[ticketId] 
    });
  };

  const handleSaveAnnotation = (ticketId) => {
    setTicketAnnotations({
      ...ticketAnnotations,
      [ticketId]: tempAnnotations[ticketId]
    });
    setEditingTickets({ ...editingTickets, [ticketId]: false });
    showSnackbar("Anotação salva com sucesso", "success");
  };

  const handleCancelEdit = (ticketId) => {
    setEditingTickets({ ...editingTickets, [ticketId]: false });
    setTempAnnotations({ ...tempAnnotations, [ticketId]: ticketAnnotations[ticketId] });
  };

  const handleAnnotationChange = (ticketId, content) => {
    setTempAnnotations({ ...tempAnnotations, [ticketId]: content });
  };

  const handleVisibilityChange = (ticketId, visibility) => {
    setAnnotationVisibility({ ...annotationVisibility, [ticketId]: visibility });
  };

  const handleMergeClick = () => {
    setConfirmModalOpen(true);
  };

  const handleClickGoToCalled = async (ticketid, newTab = true) => {

    const urlRedirect = "/pt/called-accompaniment/" + ticketid;
    setTimeout(() => {
      if(newTab) {
        window.open(urlRedirect, "_blank");
      } else {
        window.open(urlRedirect);
      }
    }, 100);
  }

  const handleConfirmMerge = async () => {
    try {
      const secondaryTickets = selectedTickets.filter(t => t.id !== principal);
      setConfirmModalOpen(false);
      const accompaniments = {};
      setLoading(true);
      
      secondaryTickets.forEach((ticket) => {
        const annotation = ticketAnnotations[ticket.id] || "";
        const visibility = annotationVisibility[ticket.id] || "private";
        
        const description = annotation ??
          `<p>O chamado com o ID <strong>#${ticket.id}</strong> foi unificado neste chamado.</p>
            <p><br></p>
            <p><strong>Título:</strong> ${ticket.title}</p>
            <p><br></p>
            <p>Foi anexado nesse chamado todos seus acompanhamentos e anexos.</p>
            <p><br></p>
            <p>Para mais informações acesse o chamado.</p>`;
        
        accompaniments[ticket.id] = {
          description: description,
          privacy: visibility
        };
      });

      const payload = {
        principalCalledId: principal,
        secondaryCalledIds: secondaryTickets.map(t => t.id),
        accompaniments: accompaniments
      };

      const response = await unificationTickets(payload);

      if (response.success) {
        showSnackbar(
          `Chamado(s) unificado(s) com sucesso.`,
          "success"
        );
        setLoading(false);
        setTimeout(() => {
          handleClose();
          handleClickGoToCalled(principal, false);
        }, 1500);
      } else {
        showSnackbar(response.errors?.[0] || "Erro ao unificar chamados", "error");
        setLoading(false);
      }
    } catch (error) {
      console.error("Erro ao unificar chamados:", error);
      
      let errorMessage = "Erro ao unificar chamados. Tente novamente";
      
      if (error.response?.data?.errors?.length > 0) {
        errorMessage = error.response.data.errors.join(", ");
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.response?.status === 401) {
        errorMessage = "Sessão expirada. Faça login novamente";
      } else if (error.response?.status === 403) {
        errorMessage = "Você não tem permissão para realizar esta ação";
      }
      
      showSnackbar(errorMessage, "error");
      setConfirmModalOpen(false);
      setLoading(false);
    }
  };

  const handleCancelMerge = () => {
    setConfirmModalOpen(false);
  };

  const quillModules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      ["clean"]
    ]
  };

  const principalTicket = selectedTickets.find((t) => t.id === principal);
  const secondaryTickets = selectedTickets.filter((t) => t.id !== principal);
  const searchResultTickets = searchResults.filter((t => t.id !== principal && !selectedTickets.some(st => st.id === t.id)));

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    
    return `Criado em ${date.toLocaleDateString('pt-BR')} ${date.toLocaleTimeString('pt-BR')}`;
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      PaperProps={{
        sx: {
          width: "40%",
          overflow: "hidden",
          borderLeft: "1px solid #ddd"
        }
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 2,
          borderBottom: "1px solid #e0e0e0"
        }}
      >
        {step === 2 && (
          <IconButton onClick={() => setStep(1)} sx={{ mr: 1 }}>
            <ArrowBackIcon />
          </IconButton>
        )}
        <Typography variant="h6" fontWeight="bold" sx={{ flex: 1 }}>
          Unificar Chamado {called.requestingusername ? `de "${called.requestingusername}"` : ""}
        </Typography>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent sx={{ background: "#f9f9f9", height: "100vh", pb: 10 }}>
        {step === 1 ? (
          <>
            {selectedTickets.length > 0 && (
              <Box>
                <Typography>
                  Interações dos chamados secundários serão adicionadas ao chamado principal. <br />
                  Só poderão ser unificados chamados do mesmo solicitante do chamado selecionado.<br />
                </Typography>
                <Typography mt={2} mb={2}>
                  <strong style={{ fontWeight: "bold" }}>Chamado Principal</strong>
                </Typography>
                <Box display="flex" flexDirection="column" gap={2}>
                  {selectedTickets.map((ticket) => {
                    const isMainTicket = principal === ticket.id;
                    const canRemoveTicket = selectedTickets.length > 1 && !isMainTicket;
                    
                    if(!isMainTicket)
                      return; 

                    return (
                      <TicketCard
                        key={ticket.id}
                        ticket={{
                          ...ticket,
                          createdAt: formatDate(ticket.createdat)
                        }}
                        isMain={isMainTicket}
                        onSelect={() => setPrincipal(ticket.id)}
                        onRemove={() => handleRemoveTicket(ticket.id)}
                        showAddIcon={false}
                        canRemove={canRemoveTicket}
                        goToCalled={() => handleClickGoToCalled(ticket.id)}
                      />
                    );
                  })}
                </Box>
              </Box>
            )}
            <Box display="flex" gap={2} mb={2} mt={2}>
              <Select
                size="small"
                value={filterType}
                onChange={(e) => {
                  setFilterType(e.target.value);
                  setSearchInput("");
                  setSearchResults([]);
                }}
              >
                <MenuItem value="titulo">Título</MenuItem>
                <MenuItem value="id">ID</MenuItem>
              </Select>

              <TextField
                variant="outlined"
                size="small"
                placeholder={filterType === "id" ? "Procurar por ID..." : "Procurar por título..."}
                fullWidth
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                type={filterType === "id" ? "number" : "text"}
                InputProps={{
                  endAdornment: !isSearching && searchInput && (
                    <Tooltip title="Limpar busca" arrow>
                      <IconButton
                        size="small"
                        onClick={clearSearch}
                        sx={{
                          marginRight: -1,
                          marginLeft: filterType === "id" ? 1 : 0
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )
                }}
              />
            </Box>

            {(isSearching || searchResultTickets.length > 0) && (
              <Paper
                elevation={2}
                sx={{
                  mt: 1,
                  mb: 3,
                  maxHeight: "300px",
                  overflowY: "auto",
                  border: "1px solid #E5E8ED"
                }}
              >
                {isSearching ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      py: 4
                    }}
                  >
                    <CircularProgress size={24} />
                    <Typography sx={{ ml: 2, color: "#6B7280" }}>
                      Procurando chamados...
                    </Typography>
                  </Box>
                ) : searchResultTickets.length > 0 ? (
                  <Box sx={{ p: 2 }}>
                    <Box display="flex" flexDirection="column" gap={2}>
                      {searchResultTickets.map((ticket) => (
                        <Paper
                          key={ticket.id}
                          elevation={0}
                          sx={{
                            border: "1px solid #E5E8ED",
                            borderRadius: "8px",
                            p: 2,
                            cursor: "pointer",
                            transition: "all 0.2s",
                            "&:hover": {
                              backgroundColor: "#F9FAFB",
                              borderColor: colorTheme
                            }
                          }}
                          onClick={() => handleAddTicket(ticket)}
                        >
                          <Box display="flex" justifyContent="space-between" alignItems="start">
                            <Box flex={1}>
                               <Button onClick={(e) => { e.stopPropagation(); handleClickGoToCalled(ticket.id);}}>
                                 <Typography sx={{
                                    fontSize: 15,
                                    fontWeight: 500,
                                    color: "#1E6BD6",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                    mb: 0.5
                                  }}>
                                  #{ticket.id}
                                </Typography>
                              </Button>
                              <Typography
                                sx={{
                                  fontSize: 15,
                                  fontWeight: 500,
                                  mb: 2
                                }}
                              >
                                {ticket.title}
                              </Typography>
                              <Typography sx={{ fontSize: 13, color: "#8993A5" }}>
                                Organização: {ticket.organizationname || "N/A"}
                              </Typography>
                              <Typography sx={{ fontSize: 13, color: "#8993A5" }}>
                                Agente: {ticket.assignedusername || "Não atribuído"}
                              </Typography>
                              <Typography sx={{ fontSize: 13, color: "#A4ACB8", mt: 0.5 }}>
                                {formatDate(ticket.createdat)}
                              </Typography>
                            </Box>
                            <IconButton
                              size="small"
                              sx={{
                                color: "#1E6BD6",
                                "&:hover": { backgroundColor: "#E3F2FD" }
                              }}
                            >
                              <AddCircleOutlineIcon />
                            </IconButton>
                          </Box>
                        </Paper>
                      ))}
                    </Box>
                  </Box>
                ) : null}
              </Paper>
            )}

            {selectedTickets.length > 0 && (
              <Box>
                <Typography
                  variant="body2"
                  sx={{ mb: 2 }}
                >
                  Chamado(s) selecionado(s) ({selectedTickets.length - 1})
                </Typography>
                <Box display="flex" flexDirection="column" gap={2}>
                  {selectedTickets.map((ticket) => {
                    const isMainTicket = principal === ticket.id;
                    const canRemoveTicket = selectedTickets.length > 1 && !isMainTicket;
                    
                    if(isMainTicket)
                      return;

                    return (
                      <TicketCard
                        key={ticket.id}
                        ticket={{
                          ...ticket,
                          createdAt: formatDate(ticket.createdat)
                        }}
                        isMain={isMainTicket}
                        onSelect={() => setPrincipal(ticket.id)}
                        onRemove={() => handleRemoveTicket(ticket.id)}
                        showAddIcon={false}
                        canRemove={canRemoveTicket}
                        goToCalled={() => handleClickGoToCalled(ticket.id)}
                      />
                    );
                  })}
                </Box>
              </Box>
            )}
          </>
        ) : (
          <>
            <Typography variant="body2" mb={3}>
              Revise os tickets que você está unificando e edite as anotações aqui
            </Typography>

            {principalTicket && (
              <Box mb={3}>
                <Paper
                  elevation={0}
                  sx={{
                    border: "1px solid #E5E8ED",
                    borderRadius: "8px",
                    p: 2,
                    position: "relative"
                  }}
                >
                  <Typography 
                    sx={{
                      fontSize: 15,
                      fontWeight: 500,
                      color: "#1E6BD6",
                      textDecoration: "underline",
                      cursor: "pointer",
                      mb: 0.5
                    }}
                    >
                      #{principalTicket.id}
                    </Typography>
                  <Typography
                    sx={{
                      fontSize: 15,
                      fontWeight: 500,
                      mb: 1
                    }}
                  >
                    {principalTicket.title}
                  </Typography>
                  <Typography sx={{ fontSize: 13, color: "#8993A5" }}>
                    Organização: {principalTicket.organizationname}
                  </Typography>
                  <Typography sx={{ fontSize: 13, color: "#8993A5" }}>
                    Agente: {principalTicket.assignedusername || "Não atribuído"}
                  </Typography>
                  <Typography sx={{ fontSize: 13, color: "#A4ACB8", mt: 0.5 }}>
                    {formatDate(principalTicket.createdat)}
                  </Typography>
                </Paper>
              </Box>
            )}

            <Box>
              <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  Chamados Secundários ({secondaryTickets.length})
                </Typography>
              </Box>

              <Box>
                {secondaryTickets.map((ticket, index) => {
                  const isEditing = editingTickets[ticket.id];
                  
                  return (
                    <Box key={ticket.id} sx={{ display: "flex", position: "relative" }}>
                      <Box
                        sx={{
                          width: "40px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          position: "relative"
                        }}
                      >
                        <Box
                          sx={{
                            width: "2px",
                            height: "24px",
                            backgroundColor: "#D1D5DB"
                          }}
                        />
                        
                        <Box
                          sx={{
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            backgroundColor: "#D1D5DB",
                            border: "2px solid #fff",
                            zIndex: 1
                          }}
                        />

                        {index < secondaryTickets.length - 1 && (
                          <Box
                            sx={{
                              width: "2px",
                              flex: 1,
                              backgroundColor: "#D1D5DB",
                              minHeight: "16px"
                            }}
                          />
                        )}
                      </Box>

                      <Box sx={{ flex: 1, ml: 1, mb: index < secondaryTickets.length - 1 ? 0 : 2 }}>
                        {!isEditing ? (
                          <Paper
                            elevation={0}
                            sx={{
                              border: "1px solid #E5E8ED",
                              borderRadius: "8px",
                              p: 2,
                              position: "relative"
                            }}
                          >
                            <Box flex={1}>
                              <Button color='primary' aria-label="call-made" onClick={() => handleClickGoToCalled(ticket.id)}>
                                <Typography sx={{
                                  fontSize: 15,
                                  fontWeight: 500,
                                  color: "#1E6BD6",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                  mb: 0.5
                                }}>
                                  #{ticket.id}
                                </Typography>
                              </Button>
                              <Typography
                                sx={{
                                  fontSize: 15,
                                  fontWeight: 500,
                                  mb: 1
                                }}
                              >
                                {ticket.title}
                              </Typography>
                              <Typography sx={{ fontSize: 13, color: "#8993A5" }}>
                                Organização: {ticket.organizationname}
                              </Typography>
                              <Typography sx={{ fontSize: 13, color: "#8993A5" }}>
                                Agente: {ticket.assignedusername || "Não atribuído"}
                              </Typography>
                              <Typography sx={{ fontSize: 13, color: "#A4ACB8", mt: 0.5 }}>
                                {formatDate(ticket.createdat)}
                              </Typography>
                            </Box>
                            <IconButton
                              onClick={() => handleEditAnnotation(ticket.id)}
                              sx={{
                                position: "absolute",
                                top: 12,
                                right: 12,
                                backgroundColor: "#F5F5F5",
                                width: 32,
                                height: 32,
                                "&:hover": {
                                  backgroundColor: "#E0E0E0"
                                }
                              }}
                            >
                              <EditIcon sx={{ color: "#8993A5", fontSize: 18 }} />
                            </IconButton>
                          </Paper>
                        ) : (
                          <Paper
                            elevation={0}
                            sx={{
                              border: "1px solid #E5E8ED",
                              borderRadius: "8px",
                              p: 2,
                              backgroundColor: "#fff"
                            }}
                          >
                            <Box mb={2}>
                               <Button onClick={() => handleClickGoToCalled(ticket.id)}>
                               <Typography sx={{
                                  fontSize: 15,
                                  fontWeight: 500,
                                  color: "#1E6BD6",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                  mb: 0.5
                                }}>
                                  #{ticket.id}
                                </Typography>
                              </Button>
                              <Typography
                                sx={{
                                  fontSize: 15,
                                  fontWeight: 500,
                                  mb: 2
                                }}
                              >
                                {ticket.title}
                              </Typography>
                            </Box>

                            <Typography variant="body2" sx={{ mb: 1, color: "#6B7280" }}>
                              Esta nota será adicionada ao chamado principal
                            </Typography>

                            <Box sx={{ mb: 2 }}>
                              <ReactQuill
                                value={tempAnnotations[ticket.id] || ""}
                                onChange={(content) => handleAnnotationChange(ticket.id, content)}
                                modules={quillModules}
                                style={{ height: "200px", marginBottom: "50px" }}
                              />
                            </Box>

                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 4 }}>
                              <Select
                                size="small"
                                value={annotationVisibility[ticket.id] || "private"}
                                onChange={(e) => handleVisibilityChange(ticket.id, e.target.value)}
                                sx={{ minWidth: 200 }}
                              >
                                <MenuItem value="private">
                                  🔒 Não visível para o contato
                                </MenuItem>
                                <MenuItem value="public">
                                  👁️ Visível para o contato
                                </MenuItem>
                              </Select>

                              <Box sx={{ display: "flex", gap: 1 }}>
                                <Button 
                                  variant="contained" 
                                  size="small"
                                  onClick={() => handleCancelEdit(ticket.id)}
                                >
                                  Cancelar
                                </Button>
                                <Button 
                                  variant="contained" 
                                  size="small"
                                  onClick={() => handleSaveAnnotation(ticket.id)}
                                >
                                  Salvar
                                </Button>
                              </Box>
                            </Box>
                          </Paper>
                        )}
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>
          </>
        )}

        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            p: 2,
            backgroundColor: "#fff",
            borderTop: "1px solid #e0e0e0",
            display: "flex",
            justifyContent: "flex-end",
            gap: 2
          }}
        >
          <Button variant="contained" color="inherit" onClick={handleClose}>
            Cancelar
          </Button>
          <Button 
            variant="contained" 
            onClick={step === 1 ? handleContinue : handleMergeClick}
            disabled={step === 1 && selectedTickets.length < 2}
          >
            {step === 1 ? "Continuar" : "Unificar"}
          </Button>
        </Box>
      </DialogContent>
          
      <CustomizedSnackbars
          variant={snackbarSeverity}
          message={snackbarMessage}
          isOpen={snackbarOpen}
          toClose={handleCloseSnackbar}
      />

      <Dialog
        open={confirmModalOpen}
        onClose={handleCancelMerge}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Typography variant="h6" fontWeight="bold">
            Você tem certeza que deseja continuar com essa ação?
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ marginTop: 2 }}>
          <Typography variant="body1">
            Todos os anexos e acompanhamentos desse chamado serão unificados ao chamado principal, sendo uma ação <strong>irreversível</strong>.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button variant="contained" color="inherit" onClick={handleCancelMerge}>
            Cancelar
          </Button>
          <Button variant="contained" onClick={handleConfirmMerge}>
            Continuar
          </Button>
        </DialogActions>
      </Dialog>

      {loading && (
        <Overlay>
          <CircularProgress color='secondary' />
        </Overlay>
      )}
    </Drawer>
  );
}